import $ from 'jquery';
import '@fancyapps/fancybox';
import * as helpers from '../helpers';

export default function initGalleries() {
    const handleFancybox = () => {
        $.fancybox.defaults.i18n.fr = {
            CLOSE: 'Fermer',
            NEXT: 'Suivant',
            PREV: 'Précédent',
            ERROR: 'Le contenu demandé ne peut être chargé. <br/> Veuillez réessayer plus tard.',
            PLAY_START: 'Démarrer le diaporama',
            PLAY_STOP: 'Pause',
            FULL_SCREEN: 'Plein écran',
            THUMBS: 'Vignettes',
            DOWNLOAD: 'Télécharger',
            SHARE: 'Partager',
            ZOOM: 'Zoom',
        };

        $.fancybox.defaults.lang = 'fr';

        $('[data-fancybox]')
            .fancybox({
                animationEffect: 'zoom',
                autoFocus: true,
                backFocus: true,
                trapFocus: false,
                clickOutside: 'close',
                idleTime: false,
                buttons: [
                    'thumbs',
                    'close',
                ],
                btnTpl: {
                    arrowLeft: `
                        <button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}">
                            <div>
                                <svg role="img" aria-label="{{PREV}}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                    <title>{{PREV}}</title>
                                    <path d="M11.28 15.7l-1.34 1.37L5 12l4.94-5.07 1.34 1.38-2.68 2.72H19v1.94H8.6z"/>
                                </svg>
                            </div>
                        </button>
                    `,
                    arrowRight: `
                        <button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}">
                            <div>
                                <svg role="img" aria-label="{{NEXT}}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                    <title>{{NEXT}}</title>
                                    <path d="M15.4 12.97l-2.68 2.72 1.34 1.38L19 12l-4.94-5.07-1.34 1.38 2.68 2.72H5v1.94z"/>
                                </svg>
                            </div>
                        </button>
                    `,

                    /* eslint-disable max-len */
                    thumbs: `
                        <button data-fancybox-thumbs class="fancybox-button fancybox-button--thumbs" title="{{THUMBS}}">
                            <svg role="img" aria-label="{{THUMBS}}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                <title>{{THUMBS}}</title>
                                <path d="M14.59 14.59h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76H5.65v-3.76zm8.94-4.47h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76H5.65v-3.76zm8.94-4.47h3.76v3.76h-3.76V5.65zm-4.47 0h3.76v3.76h-3.76V5.65zm-4.47 0h3.76v3.76H5.65V5.65z"/>
                            </svg>
                        </button>
                    `,
                    /* eslint-enable max-len */
                    close: `
                        <button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}">
                            <svg role="img" aria-label="{{CLOSE}}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                <title>{{CLOSE}}</title>
                                <path d="M12 10.6L6.6 5.2 5.2 6.6l5.4 5.4-5.4 5.4 1.4 1.4 5.4-5.4 5.4 5.4 1.4-1.4-5.4-5.4 5.4-5.4-1.4-1.4-5.4 5.4z"/>
                            </svg>
                        </button>
                    `,
                },

                afterShow(instance) {
                    const focusableElements = helpers.getFocusableElements(instance.$refs.toolbar[0], false);
                    const setStartFocus = instance.currIndex === instance.group.length - 1
                    && focusableElements.length ? (
                            focusableElements[0].focus()
                        ) : null;
                },

                beforeLoad(instance) {
                    const wrapper = instance.$refs.container[0];

                    // add custom focus trap
                    if (wrapper) {
                        wrapper.addEventListener('keydown', helpers.initFocusTrap.bind(null, wrapper));
                    }
                },

                afterLoad(instance, current) {
                    tarteaucitron.reloadThePage = false;
                    const alt = current.opts.alt;

                    const btnClose = document.querySelector('.fancybox-button.fancybox-button--close');
                    const fancyContent = document.querySelector('.fancybox-content');

                    if (btnClose && fancyContent) {
                        if (helpers.hasClass(document.body, '-in-iframe')) {
                            fancyContent.insertAdjacentElement('afterbegin', btnClose);
                        }
                    }

                    setTimeout(() => {
                        // Add custom attribute to iframe type fancybox
                        if (typeof current.$iframe !== 'undefined'
                            && instance.$trigger[0]
                            && instance.$trigger[0].hasAttribute('data-title')) {
                            current.$iframe[0].setAttribute('title', instance.$trigger[0].getAttribute('data-title'));
                        }

                        if (current.$image && current.$image.attr) {
                            if (alt) {
                                current.$image.attr('alt', alt);
                            } else {
                                current.$image.attr('alt', '');
                            }
                        }
                    }, 500);
                },

                afterClose() {
                    tarteaucitron.reloadThePage = true;
                },
            });

        const galleryList = [].slice.call(document.querySelectorAll('.gallery__list'));

        if (galleryList.length) {
            galleryList.forEach((element) => {
                const galleryItemCount = [].slice.call(element.querySelectorAll('.gallery__item')).length;
                element.setAttribute('data-items', galleryItemCount);
            });
        }
    };

    if (tarteaucitron) {
        document.addEventListener('fancybox_added', () => {
            handleFancybox();
        });
    } else {
        handleFancybox();
    }
}
